import React, { FunctionComponent } from 'react';
import styles from './RadioButtonInput.module.scss';
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from '@material-ui/core';

interface Props {
  label: string;
  options: Array<any>;
  name: string;
  error?: any;
  register?: any;
  defaultValue?: string;
  OptionsISBlocked?: boolean;
  hideRedioButton?: boolean;
  onChange?: (e: any) => void;
  value?: string | number;
  disabled?: boolean;
  fontSize?: string;
  removeLabelGap?: boolean;
}

const RadioButtonInput: FunctionComponent<Props> = ({
  label,
  options,
  name,
  error,
  register,
  defaultValue,
  OptionsISBlocked,
  hideRedioButton,
  onChange,
  value,
  disabled,
  fontSize,
  removeLabelGap,
}) => {
  return (
    <div
      className={`${styles.RadioButtonInput} ${
        hideRedioButton ? styles.RadioButtonInputIsHidden : ''
      }
      ${removeLabelGap ? styles.removeLabelGap : ''}
      `}
    >
      <FormControl>
        <div className={styles.label_required}>
          <FormLabel
            component="legend"
            id="demo-radio-buttons-group-label"
            className={disabled ? 'labelDisabled' : ''}
          >
            {label}
          </FormLabel>
          {error && <p className={styles.Error}>{error[name]?.message}</p>}
        </div>
        <RadioGroup
          data-testid="test-radio-group"
          aria-labelledby="demo-radio-buttons-group-label"
          defaultValue={defaultValue}
          value={value}
          name="radio-buttons-group"
          className={
            hideRedioButton
              ? styles.HideInput
              : `${styles.Input} ${
                  OptionsISBlocked ? styles.OptionsISBlocked : ''
                } ${disabled ? styles.InputDisabled : ''}`
          }
          style={{ fontSize: '10px' }}
        >
          {options.map(({ label, value }, i) => (
            <FormControlLabel
              data-testid={`option-radio`}
              key={i}
              disabled={disabled}
              value={value}
              {...register?.(name)}
              onChange={(e) => onChange?.(e.target)}
              control={
                <Radio
                  size="small"
                  style={{
                    display: hideRedioButton ? 'none' : 'flex',
                    fontSize: '10px',
                  }}
                  data-testid={`small-radio`}
                />
              }
              label={
                fontSize ? (
                  <div style={{ fontSize: '10px' }}>{label}</div>
                ) : (
                  label
                )
              }
            />
          ))}
        </RadioGroup>
      </FormControl>
    </div>
  );
};

export default RadioButtonInput;
